module.exports = __webpack_public_path__ + "assets/img/travel-day36.7901bd0e.png";